<template>
<div>
    <linkbutton toplabel="Update Options" @click="start()"/> 
    
    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <label for="notefield" class="titlelabel">Update Options</label>
            <input id="notefield" v-model="newNote"  class="textarea"/>
            <div>
                <smallbutton  @click="closeModal" toplabel="Save" buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel" buttonclass="button buttoncancel"/>
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import linkbutton from '../controls/linkbutton.vue'
export default {
    name:'lineitemnote',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
    },
    props:{
        ticketLineItemId:{
            type:Number
            
        },
        optionNote:{
            type:String
        }
        
    },
    mixins:[datamethods],
    data(){
        return{
            newNote:'',
            responseMessage:''
        }
    },
    methods:{
        start(){

            this.newNote=this.optionNote
            this.$refs.mymodal.openModal()
        },
        async closeModal(){
            this.responseMessage=''
            let req = {
                updatedLineItemId:this.ticketLineItemId,
                ticket:{
                    lineItems:[
                        {
                            id:this.ticketLineItemId,
                            optionNote:this.newNote
                        }
                        
                    ]
                }
            }
            var response = await this.callAPI(req,'updateticketlineitem_optionnote')
            if(response.Successful){
                this.$emit('notesaved',this.newNote)
                this.$refs.mymodal.closeModal()
                
            }else{
                this.responseMessage = response.Message
            }
        }
    }
}
</script>

<style>

</style>